<template>
    <b-container class="p-0">
        <b-row class="my-1" v-for="([prop , value], index) in Parameter.getProperties()" :key="prop + index">
                <!-- @Todo : Translate -->
                <b-col cols="3" class="m-auto">{{ prop }}</b-col>
                <b-col>
                    <b-form-select v-if="prop === 'Data'" :options="enumGridPanelData" v-model="Parameter[prop]" />
                    <b-form-input v-else-if="prop === 'PageSize'" type="number" @keydown="regexValue" :step="1" v-model="Parameter[prop]" class="text-center" />
                    <b-form-input v-else-if="typeof value === 'string'" v-model="Parameter[prop]" />
                </b-col>
            </b-row>
    </b-container>
</template>

<script lang="ts">

    import { Prop, Vue} from 'vue-property-decorator';
    import Component from 'vue-class-component';
    import VueI18n from 'vue-i18n' // translation support
    import locales from "../locales/ParametersItems.json";
    import GridPanelField from '../Class/GridPanelField';
    import { EnumGridPanelData } from '../Enums/EnumGridPanelData';

    Vue.use(VueI18n);

    @Component({
        i18n: { messages: locales }
    })
	export default class GridPanelModal extends Vue{
        /** Variant de couleur à appliquer sur le composant */
        @Prop({default: () => "secondary"})
		public Variant!: string;

        @Prop()
        public Parameter!: GridPanelField;

        private enumGridPanelData: {value: string | EnumGridPanelData, text: string}[] = Object.entries(EnumGridPanelData).filter(([key, value]) => typeof value === 'number').map(([key, value]) => ({value: value, text: key}));
        
        private regexValue(event){
            // Number 0 return 0 hors 0 = false
            if(!Number(event.key) && !this.keysToFilter.includes(event.key)){
                event.preventDefault();
            }
        }

        private keysToFilter: string[] = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', '0'];
    }

</script>

<style scoped>
    :deep(input[type=checkbox]:checked) {
        /** Change la couleur de la checkbox */
        accent-color: var(--Variant) !important;
    }

    :deep(input[type=radio]:checked) {
        /** Change la couleur du bouton radio */
        accent-color: var(--Variant) !important;
    }

    /** Pour que la page active prenne en compte la couleur de Variant */
    :deep(.page-item.active .page-link) {
        background-color: var(--Variant) !important;
    }

    :deep(.page-link:hover) {
        background-color: var(--VariantLight) !important;
    }
</style>